<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     OEE分析
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="em-oee header-padding">
    
    <f-page-header />

    <div class="oee-container">

      <el-card v-loading="loading" shadow="never">
        <!-- 工单 -->
        <div class="front-line font-18 mb-lg flex align-items-center">
          OEE分析
          <el-date-picker
            v-model="oeeDate"
            type="date"
            placeholder="请选择日期"
            class="ml-sm"
            value-format="timestamp"
            :picker-options="options"
            style="width: 160px;"
            :clearable="false"
            @change="fetchData" />
        </div>

        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat flex column">
              <div class="font-16">
                全局设备效率 OEE
              </div>
              <div v-if="effectiveness != '-'" class="flex mt align-items-end">
                <span class="font-28 number text-bold">{{ effectiveness }}</span>
                <span class="unit ml-sm">%</span>
              </div>
              <span v-else class="mt font-28 number text-bold">{{ effectiveness }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat flex column">
              <div class="font-16">
                时间稼动率
              </div>
              <div v-if="time_effectiveness != '-'" class="flex mt align-items-end">
                <span class="font-28 number text-bold">{{ time_effectiveness }}</span>
                <span class="unit ml-sm">%</span>
              </div>
              <span v-else class="mt font-28 number text-bold">{{ time_effectiveness }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat flex column">
              <div class="font-16">
                性能稼动率
              </div>
              <div v-if="property_effectiveness != '-'" class="flex mt align-items-end">
                <span class="font-28 number text-bold">{{ property_effectiveness }}</span>
                <span class="unit ml-sm">%</span>
              </div>
              <span v-else class="mt font-28 number text-bold">{{ property_effectiveness }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat flex column">
              <div class="font-16">
                良品率
              </div>
              <div v-if="qc != '-'" class="flex mt align-items-end">
                <span class="font-28 number text-bold">{{ qc }}</span>
                <span class="unit ml-sm">%</span>
              </div>
              <span v-else class="mt font-28 number text-bold">{{ qc }}</span>
            </div>
          </el-col>
        </el-row>

        <el-alert
          class="mt-lg mb-lg"
          type="info"
          :closable="false">
          <div slot="title" class="flex align-items-center">
            <i class="el-icon-warning text-danger font-lg" />
            <span class="ml-xs text-black">小贴士</span>
          </div>
          <div class="font-14">{{'OEE(Overall Equipment Effectiveness，全局设备效率) = 时间稼动率 x 性能稼动率 x 良品率'}}</div>
        </el-alert>

        <el-divider></el-divider>

        <div class="front-line font-18 mt-lg mb-lg flex align-items-center">
          趋势分析
          <el-select v-model="type" placeholder="请选择" filterable @change="selectChange" style="width:120px;" class="ml">
            <el-option
              v-for="(item, index) in radios"
              :key="index"
              :label="item.title"
              :value="item.value">
            </el-option>
          </el-select>
          
          <f-date-range-picker v-if="type == 3" v-model="trendDate" :clearable="false" :disablerange="disablerange" @change="fetchTrend" class="ml-sm" />

          <div v-else class="text-muted ml">{{ range }}</div>
          
        </div>

        <div class="chart">

          <oee-line :time="trendDate" class="mt-lg"/>

          <oee-bar :time="trendDate" class="mt-mg"/>

          <good-line :time="trendDate" class="mt-mg" />
        </div>

      </el-card>

    </div>

  </div>
</template>

<script>
import { getReportApi } from '@/api/em/oeeApi'

import dayjs from 'dayjs'
const nowDate = parseInt((new Date().getTime() / 1000).toString())
const yesterday = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24
const last7 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 7
const last30 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 30
const last90 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 90

export default {
  name: "EmOee",

  components: {
    OeeLine: () => import('./components/OeeLine'),
    OeeBar: () => import('./components/OeeBar'),
    GoodLine: () => import('./components/GoodLine'),
  },

  data() {
    var disabledDate = (date) => {
      if (this.disablerange) {
        if (this.disablerange.length === 1) {
          return date.getTime() < this.disablerange[0] * 1000
        } else {
          return date.getTime() < this.disablerange[0] * 1000 || date.getTime() > this.disablerange[1] * 1000
        }
      } else {
        return false
      }
    }
    return {
      options: {
        disabledDate: disabledDate
      },
      disablerange: [last90, yesterday],
      trendDate: [],
      oeeDate: yesterday * 1000,

      effectiveness: null,
      property_effectiveness: null,
      qc: null,
      time_effectiveness: null,

      date: new Date(yesterday * 1000),
      loading: false,
      type: 1,
      radios: [
        { value: 1, title: '最近7天' },
        { value: 2, title: '最近30天' },
        { value: 3, title: '自定义' }
      ],
    }
  },

  computed: {
    range() {
      return dayjs(this.startDate * 1000).startOf('day').format('YYYY-MM-DD') + ' 至 ' + dayjs(this.endDate * 1000).startOf('day').format('YYYY-MM-DD')
    },

    startDate() {
      if (this.trendDate.length) return this.trendDate[0]
    },

    endDate() {
      if (this.trendDate.length) return this.trendDate[1]
    }
  },

  created() {
    if (this.type == 1) this.trendDate = [last7, yesterday + 86399]
    if (this.type == 2) this.trendDate = [last30, yesterday + 86399]
    this.fetchData()
  },

  watch: {
  },

  methods: {
    fetchData() {
      this.loading = true
      getReportApi({time: this.oeeDate / 1000}).then(res => {
        this.loading = false
        if (!res.errno) {
          this.effectiveness = res.data.effectiveness
          this.property_effectiveness = res.data.property_effectiveness
          this.qc = res.data.qc
          this.time_effectiveness = res.data.time_effectiveness
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchTrend() {},

    selectChange() {
      if (this.type == 1) this.trendDate = [last7, yesterday + 86399]
      if (this.type == 2) this.trendDate = [last30, yesterday + 86399]
    }
  }

}
</script>

<style lang="scss" scoped>
.em-oee {
  position: relative;
  .oee-container {
    width: 1080px;
    margin: 0 auto;
    .stat {
      height: 120px;
      width: 100%;
      background: #F8F9FC;
      padding: 20px;
      border-radius: 4px;
      .unit {
        line-height: 24px;
      }
    }
    .chart {
      padding: 0 30px 20px;
    }
  }
}
</style>
